<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "404 Error Page",
    meta: [{ name: "description", content: appConfig.description }],
  },
};
</script>
<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>3
            </h1>
            <h4 class="text-uppercase">
              Maaf, Anda tidak memiliki hak untuk mengakses halaamn tujuan.
            </h4>
            <div class="mt-5 text-center">
              <a class="btn btn-primary" @click="$router.go(-1)">
                Kembali ke halaman sebelumnya
              </a>
              <br />
              <br />
              <a
                class="btn btn-primary"
                @click="$router.push({name: 'logout'})"
              >
                Login kembali
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
